// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"c16c9036","218":"3704c927","233":"9d45bb2d","279":"f8c1d5e1","377":"51ebe1e1","473":"a748b0ad","576":"b0b96686","833":"0fd6ce12"}[chunkId] + ".chunk.js";
};